module.exports = __webpack_public_path__ + "img/signquick.09eaa63e.png";